import React,{useEffect} from 'react';
import {routes} from "../datamodels/routes";
import {updateAppSettings} from "../actions/foundationActions";
import store from "../store";


const URLParser = () => {
    useEffect(()=>{
        if(routes.hasOwnProperty(window.location.pathname.toLowerCase())){
            store.dispatch(updateAppSettings({routedComponent:routes[window.location.pathname.toLowerCase()].component}))
        }
    },[]);
    return <div id="urlParser" style={{display:"none"}}>Parser</div>
};

export default URLParser;
